/**
 * kd-recommended-carousel: TOP「あなたにおすすめ」セクション
 *
 * issue #3074 — データソース未確定。
 * Algolia Personalize / Algolia Recommend / 別社 API などの候補があり、
 * 商品取得・DOM 注入ロジックは別会社が後追いで実装する想定。
 *
 * 本ファイルではカスタム要素の登録のみ行う。
 * 表示窓のスケルトンは Liquid 側 (sections/v2-top-recommended.liquid) が描画する。
 * display-num 属性は HTML 属性として残してあるため、別会社実装は
 * `element.getAttribute('display-num')` で取得可能。
 */
import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('kd-recommended-carousel')
export class KdRecommendedCarousel extends LitElement {
  createRenderRoot() {
    return this;
  }

  render() {
    return nothing;
  }
}
